module.exports = __webpack_public_path__ + "img/公司主页图片.15bff8d1.png";